import { AppointmentDetails, PreviousAppointmentLocalstorage } from '../../../types/consultation';
import { startSpan as sentryStartSpan, captureException } from '@sentry/browser';

const localstorageKey = 'lastAppointment';

// Sentry helper to wrap lookups/fetches without breaking older browsers.
const startSpan = <T>(name: string, op: string, attributes: Record<string, unknown>, cb: () => T) => (sentryStartSpan as any)?.({ name, op, attributes }, cb) ?? cb();

export async function getPreviousAppointment(email?: string, phone?: string) {
  return startSpan('consultation.appointment.lookup', 'function', { hasEmail: !!email, hasPhone: !!phone }, async () => {
    const lastConsultationEntry = JSON.parse(window.localStorage.getItem(localstorageKey) || 'false') as PreviousAppointmentLocalstorage;

    if (!lastConsultationEntry || (email ? email !== lastConsultationEntry.email : phone !== lastConsultationEntry.phone)) {
      return;
    }

    if (lastConsultationEntry.isCallback) {
      return { type: 'callback', consentConfirmed: lastConsultationEntry.consentConfirmed };
    }

    if (lastConsultationEntry.appointmentId) {
      return await getAppointmentData(lastConsultationEntry.appointmentId);
    }
  });
}

export function setPreviousAppointment(id?: string, email: string = '', phone: string = '', consentConfirmed: boolean = false, isCallback = false) {
  const lastConsultationEntry = JSON.parse(window.localStorage.getItem(localstorageKey) || 'false') as PreviousAppointmentLocalstorage;

  if (lastConsultationEntry?.appointmentId && isCallback && email === lastConsultationEntry.email) {
    return;
  }

  const previousAppointment: PreviousAppointmentLocalstorage = { email, phone, appointmentId: id, consentConfirmed, isCallback };

  window.localStorage.setItem(localstorageKey, JSON.stringify(previousAppointment));
}

export function getAppointmentData(id: string) {
  let isResponseOk = false;
  return startSpan(
    'consultation.appointment.lookup',
    'http.client',
    { appointmentId: id },
    () =>
      new Promise<AppointmentDetails>((resolve, reject) => {
        fetch(`${window.craftConfig.global.appointmentServiceUrl}/appointment-details/public/${id}`)
          .then(response => {
            isResponseOk = response.ok;
            return response.json();
          })
          .then(data => {
            if (!isResponseOk) {
              const errorMessage = data.error ? data.error.message : '';
              const error = new Error(`error: ${errorMessage || ''}`);
              captureException(error, { extra: { appointmentId: id, status: data?.error?.code } });
              reject(error);
            }
            resolve(data.result);
          })
          .catch(error => {
            captureException(error, { extra: { appointmentId: id } });
            reject(error);
          });
      })
  );
}
